"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const checkProgressValue_1 = __importDefault(require("../recovery-week-overview/checkProgressValue"));
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const tags_1 = require("../../atoms/tags");
// TODO: Uncomment reason when know how to handle explanation for progress
exports.default = ({ title, value, isProgress = false }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { isProgress: isProgress, children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: title }, void 0), (0, jsx_runtime_1.jsx)("div", { children: isProgress ? ((0, jsx_runtime_1.jsx)("div", { children: typeof value === "string" ? ((0, jsx_runtime_1.jsx)(tags_1.Tag, { variant: "silver", children: value }, void 0)) : ((0, checkProgressValue_1.default)(value.status, true)) }, void 0)) : ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "light-grey", children: value || "-" }, void 0)) }, void 0)] }, void 0));
};
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex: 1;
  justify-content: space-between;
  text-align: center;

  p {
    line-height: 1.5rem;
    margin-bottom: 0;
    padding: 0;
  }

  & > p {
    color: ${({ isProgress, theme }) => isProgress ? theme.colors.greyBase : theme.colors.greyLighten40};
  }

  & > div {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  & > div p {
    margin-top: ${({ theme }) => theme.spacings.xs};
  }
`;
//# sourceMappingURL=Row.js.map